import {Pipe, PipeTransform} from '@angular/core';
import {Globalize} from '@mescius/wijmo';

// Standalone, pure pipe to format values using Wijmo's Globalize
// Usage: {{ value | wijmoFormat: formatPattern }}
@Pipe({
    name: 'wijmoFormat',
    standalone: true,
    pure: true
})
export class WijmoFormatPipe implements PipeTransform {
    transform(value: unknown, formatPattern: string): string {
        if (value == null) {
            // null or undefined -> empty string per requirement
            return '';
        }

        const pattern: string = formatPattern;

        try {
            // Delegate formatting to Wijmo Globalize
            // Globalize.format accepts numbers, dates, etc.
            return Globalize.format(value as any, pattern);
        } catch (_err) {
            // On any formatting error, fall back to a safe string representation
            return value.toString();
        }
    }
}
